import { render } from "./shutdownList.vue?vue&type=template&id=ff606a0e&scoped=true"
import script from "./shutdownList.vue?vue&type=script&lang=js"
export * from "./shutdownList.vue?vue&type=script&lang=js"

import "./shutdownList.vue?vue&type=style&index=0&id=ff606a0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ff606a0e"

export default script